import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Chatbot from './components/chatbot';


import Home from './pages/Home';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Products from './pages/Products';
import Services from './pages/Services';
import SingleBlog from './pages/SingleBlog';

import GovernmentSchemes from "./pages/GovernmentSchemes";
import SeedInformation from "./pages/SeedInformation";
import CropPestDiseaseControl from "./pages/CropPestDiseaseControl";
import FarmMachinery from "./pages/FarmMachinery";
import FarmingGuidance from "./pages/FarmingGuidance";
import WaterManagement from "./pages/WaterManagement";

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            {/* Main Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />

            {/* Blog Routes */}
             <Route path="/blog" element={<Blog />} />
      <Route path="/article/:slug.php" element={<SingleBlog />} />

            {/* Service Pages */}
            <Route path="/government-schemes" element={<GovernmentSchemes />} />
            <Route path="/seed-information" element={<SeedInformation />} />
            <Route path="/crop-pest-disease-control" element={<CropPestDiseaseControl />} />
            <Route path="/farm-machinery" element={<FarmMachinery />} />
            <Route path="/farming-guidance" element={<FarmingGuidance />} />
            <Route path="/water-management" element={<WaterManagement />} />

            {/* 404 Page - Optional */}
            <Route path="*" element={<NotFound />} />

          </Routes>

          <Chatbot />
        </main>
        <Footer />
      </div>
    </>
  );
}

// 404 Page
function NotFound() {
  return (
    <div className="text-center py-20">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">404 - Page Not Found</h1>
      <p className="text-lg text-gray-600 mb-6">The page you're looking for doesn't exist.</p>
      <a
        href="/"
        className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
      >
        Return Home
      </a>
    </div>
  );
}

// function Bot() {
//   return (
    
//       <div className="Bot">
//         <Chatbot />
//       </div>
  
//   );
// }

export default App;
